<div class="table_wrapper_invoice">
        <!-- <teemapp-v2-table-menu *ngIf="menuItems && menuItems.length > 0 && selected.length > 0"
        	[menuItems]="menuItems"
        	[isActive]="showMenu"
            [itemSelected]="selected"
            (menuClicked)="onMenuClick($event)"
            (hideMenu)="hideMenu($event)"
        ></teemapp-v2-table-menu> -->
        
        <!-- <table basic-table [data]="data" class="data-table__table {{!selectable ? (name !== 'invoices' ) ? 'not-selectable' : '' : ''}}" [ngClass]="tableClass"> -->
        <table class="marketing_table" id="activatedTable" basic-table [data]="data" [ngClass]="tableClass">
            <thead>
                <tr>
                    <th *ngIf="selectable" class="th-check" scope="col">
                        <input class="styled-checkbox view-select-all" id="{{name}}-view-select-all" type="checkbox" (click)="toggleSelectAll()" [checked]="data && data.length > 0 && selected.length == data.length">
                        <label for="{{name}}-view-select-all"></label>
                    </th>

                    <th *ngFor="let header of tableSchema.headers; last as isLast" class="{{header.thClass}}" scope="col" >{{header.label}}</th>

                    <!-- <th *ngIf="menuItems && menuItems.length > 0" class="th-navigation">
                        <span *ngIf="selected.length > 0"  class="hamburger-menu table-menu table-dropdown-trigger" (click)="toggleMenu()">
                            <div class="hamburger hamburger--spring" [ngClass]="{'is-active' : showMenu}" >
                                <div class="hamburger-box">
                                    <div class="hamburger-inner"></div>
                                </div>
                            </div>
                        </span>
                    </th> -->
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="data && data.length > 0; else noRecord">
                    <tr *ngFor="let row of data | paginate: paginator; index as i">
                        <td class="td-check" *ngIf="selectable">
                            <input class="styled-checkbox" id="{{name}}-styled-checkbox-{{i}}" type="checkbox" (click)="toggleSelect(row[selectKey], row)" [checked]="selected.includes(row[selectKey])">
                            <label for="{{name}}-styled-checkbox-{{i}}"></label>
                        </td>

                        <td *ngFor="let col of tableSchema.cols; last as isLast" class="{{ col.tdClass}}" [innerHtml]="col.render ? (col.render(row[col.key], row) | safe:'html') : row[col.key]" (click)="col.dataClick && col.dataClick($event, row[col.key], row)">
                        </td>

                        <!-- <td *ngIf="menuItems && menuItems.length > 0" class="td-navigation">
                            <a *ngIf="selected.length > 0"  href="javascript:void(0);" class="inner-navigation"><span></span><span></span><span></span></a>
                        </td> -->
                        <!-- <div class="position-relative">
                                <teemapp-v2-table-menu *ngIf="menuItems && menuItems.length > 0 && activeRow === row?.uuid"
                                    [menuItems]="menuItems"
                                    [isActive]="activeRow === row?.uuid"
                                    [itemSelected]="selected"
                                    (menuClicked)="onMenuClick($event)"
                                    (hideMenu)="hideMenu($event)"
                                ></teemapp-v2-table-menu>
                                <div class="dots_container-rounded w-100" (click)="toggleActions(row?.uuid)">
                                    <svg class="dots-menu" xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                        <path d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div> -->
                    </tr>
                </ng-container>

                <ng-template #noRecord>
                    <tr>
                        <td [attr.colspan]="totalTableColumns" class="text-center font-weight-normal"> 
                            <ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container> 
                            <ng-template #noRecord>
                                <ng-container i18n="@@common.no_record_found">No record found.</ng-container> 
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>

        <ng-container *ngIf="paginator.totalItems > 0">
            <div class="pagination_wrapper">
                <div class="showing_results">
                    <div class="select_wrapper">
                        <ng-container i18n="@@show">Show</ng-container>
                        <select class="select-link tab-links-select" id="tab-links-select" nice-select [(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
                            <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                        </select>
                        <ng-container i18n="@@items">items</ng-container>
                    </div>
                    <div class="results_list" *ngIf="paginator?.from || paginator?.to">
                        <ng-container i18n="@@showing_from">Showing from</ng-container> {{ paginator?.from }} <ng-container i18n="@@to">to</ng-container> {{ paginator?.to }} <ng-container i18n="@@of">of</ng-container> {{ paginator?.totalItems }} <ng-container i18n="@@items">items</ng-container>
                    </div>
                </div>
                <nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">
                    <ul class="pagination justify-content-center">
                        <li class="page-item" [class.disabled]="p.isFirstPage()">
                            <a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
                                <svg  width="7.5" height="13.5"><path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
                            </a>
                        </li>

                        <li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value" >
                            <a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
                                <span>{{ page.label }}</span>
                            </a>
                            <a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
                            <span class="sr-only">(current)</span></a>
                        </li>
                        
                        <li class="page-item" [class.disabled]="p.isLastPage()">
                            <a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
                                <svg width="7.5" height="13.5"><path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </ng-container>
    
</div><!-- end outer-table-wrap -->